import axios from 'axios';

export const handleGetListForms = ({
  sectionUrls,
  token,
  setLoading,
  setList,
  setCount,
  setError
}) => {
  setLoading(true);

  axios
    .get(sectionUrls.AllForm, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      setLoading(false);
      setList(response.data.output.forms);
      setCount(response.data.output.pageCount);
    })
    .catch((err) => {
      setError(err);
      console.error("Error fetching data:", err);
    });
};
